import { Stack, TextField, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleApproverSubmission } from "../../Redux/Mailer";
import "./vivaSubmissionConfirmPopup.css";
const Icon = styled("img")({
  width: 24,
  // Adjust the size to your needs
  height: 24
});
const BootstrapDialog = styled(Dialog)(({
  theme
}) => ({
  "& .MuiDialogContent-root": {
    minWidth: "470px"
  },
  "& .MuiDialogActions-root": {}
}));
export default function VivaSubmissionConfirmPopup(props) {
  const handleClose = () => {
    props.setOpen(false);
  };
  const [checked, setChecked] = React.useState(false);
  const [checkedB, setCheckedB] = React.useState(false);
  const [userData, setUserData] = React.useState("");
  const dispatch = useDispatch();
  const campaignID = useSelector(state => state.model.campaignID);
  const isSubmitted = useSelector(state => state.model.isSubmitted);
  const userID = useSelector(state => state.model.userID);
  const handleChangeRadioButton = (event, label) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      setCheckedB(false);
    }
  };
  const handleChangeRadioButtonB = (event, label) => {
    setCheckedB(event.target.checked);
    if (event.target.checked) {
      setChecked(false);
    }
  };
  const handleSubmit = () => {
    let data = {
      model: props.modalResponse,
      user: userID,
      category: props.categoryName,
      subCategory: props.mailerParent,
      type: props.mailerChild,
      programname: props.programName,
      campaignID: campaignID,
      userData: userData
    };
    dispatch(handleApproverSubmission(data));
  };
  return <React.Fragment>
   <BootstrapDialog open={props.open} onClose={handleClose} aria-labelledby="customized-dialog-title">
    {isSubmitted == true ? <Stack sx={{
        justifyContent: "center"
      }}>
      <DialogContent sx={{
          marginTop: "20px"
        }}>
       <Stack sx={{
            justifyContent: "center",
            alignItems: "center"
          }} spacing={1}>
        <img src={process.env.PUBLIC_URL + "/Images/Popup/greentick.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-1"></img>
        <Typography sx={{
              textAlign: "center",
              fontSize: "18px",
              fontFamily: "Graphik-Medium"
            }}>
         {" "}
         You have successfully submitted <br></br> for the approval.
        </Typography>
       </Stack>
      </DialogContent>
      <DialogActions sx={{
          justifyContent: "center",
          paddingBottom: "30px"
        }}>
       <img onClick={() => {
            handleClose();
            props.handleReset();
          }} src={process.env.PUBLIC_URL + "/Images/Popup/donebutton.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-2"></img>
      </DialogActions>
     </Stack> : isSubmitted == false ? <Stack>
      <DialogContent sx={{
          marginTop: "20px"
        }}>
       <Stack sx={{
            justifyContent: "center",
            alignItems: "center"
          }} spacing={1}>
        <img src={process.env.PUBLIC_URL + "/Images/Popup/greentick.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-3"></img>
        <Typography sx={{
              textAlign: "center",
              fontSize: "18px",
              fontFamily: "Graphik-Medium"
            }}>
         {" "}
         You have failed to submit the approval. <br></br> Please try again later.
        </Typography>
       </Stack>
      </DialogContent>
      <DialogActions sx={{
          justifyContent: "center",
          paddingBottom: "30px"
        }}>
       <img onClick={() => {
            handleClose();
            props.handleReset();
          }} src={process.env.PUBLIC_URL + "/Images/Popup/donebutton.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-4"></img>
      </DialogActions>
     </Stack> : <Stack sx={{
        background: "white"
      }}>
      <IconButton aria-label="close" sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: theme => theme.palette.grey[500]
        }}>
       <img onClick={() => {
            handleClose();
          }} src={process.env.PUBLIC_URL + "/Images/Popup/closeicon.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-5"></img>
      </IconButton>
      <DialogContent sx={{
          padding: "50px 30px 30px 30px"
        }}>
       <Stack spacing={1}>
        <Stack>
         <Typography sx={{
                textAlign: "center",
                fontSize: "18px",
                fontFamily: "Graphik-Medium"
              }}>
          Do you want to enter
         </Typography>
         <Typography sx={{
                textAlign: "center",
                fontFamily: "Graphik-Medium",
                fontSize: "18px"
              }}>
          any additional information?
         </Typography>
        </Stack>

        <FormGroup sx={{
              flexDirection: "row",
              justifyContent: "center"
            }}>
         <FormControlLabel control={<Checkbox checked={checked} sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 28
                }
              }} onChange={e => {
                handleChangeRadioButton(e, "Yes");
              }} icon={<Icon src={process.env.PUBLIC_URL + "/Images/Popup/unchecked.png"} alt="icon" />} checkedIcon={<Icon src={process.env.PUBLIC_URL + "/Images/Popup/circlecheckbox.png"} alt="icon" />} />} label="Yes" />

         <FormControlLabel control={<Checkbox checked={checkedB} sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 28
                }
              }} onChange={e => {
                handleChangeRadioButtonB(e, "No");
              }} icon={<Icon src={process.env.PUBLIC_URL + "/Images/Popup/unchecked.png"} alt="icon" />} checkedIcon={<Icon src={process.env.PUBLIC_URL + "/Images/Popup/circlecheckbox.png"} alt="icon" />} />} label="No" />
        </FormGroup>
       </Stack>
       {checked && <Stack sx={{
            marginTop: "20px",
            width: "400px"
          }}>
         <Typography sx={{
              fontFamily: "Graphik-Regular"
            }}>
          Enter the information
         </Typography>
         <TextField sx={{
              width: "100%"
            }} onChange={e => setUserData(e.target.value)} multiline maxRows={5} minRows={5} />
        </Stack>}
      </DialogContent>
      {(checked || checkedB) && <DialogActions sx={{
          justifyContent: "center",
          paddingBottom: "30px"
        }}>
        <img onClick={() => {
            handleSubmit();
          }} src={process.env.PUBLIC_URL + "/Images/Popup/Submit.png"} className="migrated-style-vivasubmissionconfirmpopup-77198f-6"></img>
       </DialogActions>}
     </Stack>}
   </BootstrapDialog>
  </React.Fragment>;
}
